import { useEffect, useRef } from 'react';
import type CardLocation from '@alltrails/amplitude/enums/CardLocation';
import logTripPlannerCTAViewed from '@alltrails/amplitude/events/logTripPlannerCTAViewed';

/**
 * Logs that a trip planner entry point was viewed, once per mount, the first time it is visible.
 */
const useLogTripPlannerCTAViewed = (entryPoint: CardLocation, isVisible = true) => {
  const hasLoggedViewRef = useRef(false);

  useEffect(() => {
    if (!isVisible || hasLoggedViewRef.current) {
      return;
    }
    hasLoggedViewRef.current = true;
    logTripPlannerCTAViewed({ entry_point: entryPoint });
  }, [entryPoint, isVisible]);
};

export default useLogTripPlannerCTAViewed;
